import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useNotification, useRequest } from 'shared/hooks';
import { BUTTON_COLORS, VARIANTS } from 'shared/constants';
import UserPrompt from 'shared/components/UserPrompt';
import { deleteDevices } from './tenantServices';

/**
 * @param {Object} props
 * @param {Function} props.afterDelete - Callback function to execute after deletion
 * @param {Array<Object>} props.devices - Array of device objects to delete
 */
export default function DeviceDeleteButton(props) {
  const {
    afterDelete,
    devices,
  } = props;

  const { request } = useRequest();
  const {
    pushSuccess,
    pushInfo,
  } = useNotification();
  const [open, setOpen] = useState(false);

  if (!devices || devices.length === 0) return null;

  const onDelete = async () => {
    const numDeleted = await deleteDevices(request, devices);
    if (devices.length === 1 && numDeleted === 1) {
      pushSuccess(`Deleted "${devices[0].name}"`);
    } else {
      // Use info because there could have been an error earlier that we don't want to remove.
      pushInfo(`Deleted ${numDeleted}/${devices.length} devices`);
    }

    afterDelete();
  };

  const text = devices.length === 1 ? 'Delete device' : `Delete ${devices.length} devices`;
  const description = `Are you sure you wish to delete ${devices.length > 1 ? 'these devices' : 'this device'}?`;

  return (
    <>
      <UserPrompt
        isOpen={open}
        message={description}
        title="Confirm Device Deletion"
        denyCallback={() => setOpen(false)}
        acceptBtnText={text}
        acceptCallback={onDelete}
        primaryBtnColor={BUTTON_COLORS.error}
      />
      <Button
        color={BUTTON_COLORS.error}
        onClick={() => setOpen(true)}
        variant={VARIANTS.contained}
      >
        {text}
      </Button>
    </>
  );
}
